import { render, staticRenderFns } from "./TinyInvoice.vue?vue&type=template&id=32d1adb8"
import script from "./TinyInvoice.vue?vue&type=script&lang=js"
export * from "./TinyInvoice.vue?vue&type=script&lang=js"
import style0 from "./TinyInvoice.vue?vue&type=style&index=0&id=32d1adb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports